// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import SvgColor from "../../../components/svg-color";
const icon = (name) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const ICONS = {
  user: icon("customer"),
  lock: icon("settings"),
  staff: icon("staff"),
  Inventory: icon("inventory"),
  analytics: icon("report"),
  dashboard: icon("dashboard"),
};

const navConfig = [
  // GENERAL
  {
    subheader: "Welcome Back!",
    items: [
      {
        title: "dashboard",
        path: PATH_DASHBOARD.general.app,
        pathList: [PATH_DASHBOARD.general.app],
        icon: ICONS.dashboard,
      },
      // STAFF
      {
        title: "staff",
        path: PATH_DASHBOARD.user.account,
        pathList: [
          PATH_DASHBOARD.user.account,
          PATH_DASHBOARD.user.new,
          PATH_DASHBOARD.user.list,
          PATH_DASHBOARD.user.profile,
          PATH_DASHBOARD.desigination.new,
          PATH_DASHBOARD.user.edit,
          PATH_DASHBOARD.user.replicate,
        ],
        icon: ICONS.staff,
      },

      // Stock
      {
        title: "stock",
        path: PATH_DASHBOARD.stock.display,
        pathList: [
          PATH_DASHBOARD.stock.display,
          PATH_DASHBOARD.stock.new,
          PATH_DASHBOARD.stock.edit,
          // PATH_DASHBOARD.inventory.adjustment,
          // PATH_DASHBOARD.inventory.adjustmentEdit,

          // PATH_DASHBOARD.inventory.replicate,
        ],
        icon: ICONS.Inventory,
      },

      // Live Stock
      {
        title: "Live stock",
        path: PATH_DASHBOARD.stock.live,
        pathList: [PATH_DASHBOARD.stock.live],
        icon: ICONS.Inventory,
      },
      // Live Stock
      {
        title: "Adjustment",
        path: PATH_DASHBOARD.stock.adjustment,
        pathList: [
          PATH_DASHBOARD.stock.adjustment,
          PATH_DASHBOARD.stock.addAdjustment,
          PATH_DASHBOARD.stock.adjustmentEdit,
        ],
        icon: ICONS.Inventory,
      },

      // Ingredient
      {
        title: "Item",
        path: PATH_DASHBOARD.item.list,
        pathList: [
          PATH_DASHBOARD.item.list,
          PATH_DASHBOARD.item.new,
          PATH_DASHBOARD.item.edit
        ],
        icon: ICONS.Inventory,
      },

      // Purchase Order
      {
        title: "Purchase Order",
        path: PATH_DASHBOARD.stock.purchaseOrders,
        pathList: [
          PATH_DASHBOARD.stock.purchaseOrders,
          PATH_DASHBOARD.stock.addPurchaseOrders,
          PATH_DASHBOARD.stock.purchaseOrderEdit,
        ],
        icon: ICONS.Inventory,
      },

      // Stock Transfers
   
      {
        title: "Stock Transfers",
        path: PATH_DASHBOARD.stock.stockTransfer,
        pathList: [
          PATH_DASHBOARD.stock.stockTransfer,
          PATH_DASHBOARD.stock.addStockTransfer,
          PATH_DASHBOARD.stock.stockTransferEdit,
        ],
        icon: ICONS.Inventory,
      },

      // Suppliers
      {
        title: 'suppliers',
        path: PATH_DASHBOARD.supplier.list,
        pathList: [
          PATH_DASHBOARD.supplier.new,
          PATH_DASHBOARD.supplier.list,
          PATH_DASHBOARD.supplier.edit,
          PATH_DASHBOARD.supplier.replicate,
        ],
        icon: ICONS.user,
      },

      // Invoice
      {
        title: "Invoice",
        path: PATH_DASHBOARD.invoice.list,
        pathList: [
          PATH_DASHBOARD.invoice.list,
        ],
        icon: ICONS.Inventory,
      },
      // REPORTS
      {
        title: "report",
        path: PATH_DASHBOARD.general.report,
        pathList: [PATH_DASHBOARD.general.report],
        icon: ICONS.analytics,
      },
      {
        title: "settings",
        path: PATH_DASHBOARD.settings.new,
        pathList: [
          PATH_DASHBOARD.settings.new,
          PATH_DASHBOARD.settings.kds,
          PATH_DASHBOARD.settings.edit,
        ],
        icon: ICONS.lock,
      },
    ],
  },
];

export default navConfig;
